import React, { useState } from 'react';
import { Button, Form, InputGroup } from "react-bootstrap";
import { PencilFill, Trash } from "react-bootstrap-icons";
import { useTranslation } from 'react-i18next';
import GameLabelRenamer from "./GameLabelRenamer";

function GameLabelEditor(props) {
    const { t } = useTranslation('messages');
    const [newLabel, setNewLabel] = useState("");

    return (
        <>
            <Form className="mb-4" onSubmit={(e) => submitNewLabel(e, props.addNewLabel, newLabel, setNewLabel)}>
                <InputGroup>
                    <Form.Control
                        type="text"
                        placeholder={t('private_area.games_tab.labels_new_form_placeholder')}
                        value={newLabel}
                        onChange={e => setNewLabel(e.target.value)}
                    />
                    <Button variant="outline-secondary" type="submit" className="fw-semibold">
                        {t('private_area.games_tab.labels_new_form_button_text')}
                    </Button>
                </InputGroup>
            </Form>

            <div className="d-flex flex-column gap-2">
                {props.gameLabels.map((gameLabel) => (
                    <div key={gameLabel.gameLabelId}
                        className="d-flex align-items-center justify-content-between rounded px-3 py-2 shadow-sm"
                        style={{ backgroundColor: '#f8f9fa' }}>
                        <span className="fw-semibold text-dark">{gameLabel.name}</span>
                        <div className="d-flex gap-2">
                            <GameLabelRenamer gameLabel={gameLabel} renameLabel={props.renameLabel} />
                            <Button
                                size="sm"
                                variant="outline-danger"
                                onClick={() => props.deleteLabel(gameLabel.gameLabelId)}>
                                <Trash size={14} />
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

function submitNewLabel(e, addNewLabel, newLabel, setNewLabel) {
    e.preventDefault();
    if (!newLabel) return;
    addNewLabel(newLabel);
    setNewLabel("");
}

export default GameLabelEditor;
